import axios from 'axios';
import { addressToString } from '../index.js';
export const addressToKVHX = async (address) => {
    if (address.KVHX) {
        return address.KVHX;
    }
    if (!Object.values(address).some((v) => v)) {
        return null;
    }
    const addressRes = await axios
        .get(`https://api.dataforsyningen.dk/adresser?q=${encodeURIComponent(addressToString(address, {
        noCoAddress: true,
        noCountry: true,
    }))}`)
        .then((r) => r.data);
    if (addressRes && addressRes[0]?.kvhx) {
        return addressRes[0].kvhx;
    }
    const addressWithFuzzySearchRes = await axios
        .get(`https://api.dataforsyningen.dk/adresser?q=${encodeURIComponent(addressToString(address, {
        noCoAddress: true,
        noCountry: true,
    }))}&fuzzy=true`)
        .then((r) => r.data);
    return ((addressWithFuzzySearchRes && addressWithFuzzySearchRes[0]?.kvhx) || null);
};
//# sourceMappingURL=index.js.map